import { colors } from '../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  select: {
    position: 'relative',
    '& > .MuiInputBase-input': {
      paddingLeft: '32px !important',
    },
    '&:after': {
      position: 'absolute',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: colors.neutral600,
      left: 16,
      top: 20,
      zIndex: 1,
      content: '""',
    },
  },
  selectRESOLVED: {
    '&:after': {
      backgroundColor: colors.textResolved,
    },
  },
  selectPOSITIVE: {
    '&:after': {
      backgroundColor: colors.textResolved,
    },
  },
  selectNEGATIVE: {
    '&:after': {
      backgroundColor: colors.textHigh,
    },
  },
  selectMISREPORTED: {
    '&:after': {
      backgroundColor: colors.destructive600,
    },
  },
  selectHIGH: {
    '&:after': {
      backgroundColor: colors.textHigh,
    },
  },
  selectLOW: {
    '&:after': {
      backgroundColor: colors.cyan600,
    },
  },
  selectMEDIUM: {
    '&:after': {
      backgroundColor: colors.orange600,
    },
  },
  selectUNRELATED: {
    '&:after': {
      backgroundColor: colors.neutral600,
    },
  },
  selectTO_BE_PRESCRIBED: {
    '&:after': {
      backgroundColor: colors.bgCritical,
    },
  },
  selectE_PRESCRIPTION_STARTED: {
    '&:after': {
      backgroundColor: colors.bgCritical,
    },
  },
  selectE_PRESCRIPTION_FAILED: {
    '&:after': {
      backgroundColor: colors.bgCritical,
    },
  },
  selectCRITICAL: {
    '&:after': {
      backgroundColor: colors.bgCritical,
    },
  },
});
